import { render, staticRenderFns } from "./ilist.vue?vue&type=template&id=f40a0528&"
import script from "./ilist.vue?vue&type=script&lang=js&"
export * from "./ilist.vue?vue&type=script&lang=js&"
import style0 from "./ilist.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/.15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports